var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app"},[_c('smoo-header'),_c('home'),_c('router-view'),_c('smoo-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }